import { render, staticRenderFns } from "./ccBuyRecord.vue?vue&type=template&id=1c4fdf6d&scoped=true"
import script from "./ccBuyRecord.vue?vue&type=script&lang=js"
export * from "./ccBuyRecord.vue?vue&type=script&lang=js"
import style0 from "./ccBuyRecord.vue?vue&type=style&index=0&id=1c4fdf6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fdf6d",
  null
  
)

export default component.exports